import { initializeApp } from 'firebase/app'
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
} from 'firebase/auth'
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyBHJWYJWqaESjZrGCkuQgzFLxi_pUZ-2fE',
  authDomain: 'shopgpt-demo.firebaseapp.com',
  projectId: 'shopgpt-demo',
  storageBucket: 'shopgpt-demo.appspot.com',
  messagingSenderId: '423178551649',
  appId: '1:423178551649:web:e8f3b5a8d5c3c3b0a0a0a0',
}
// Initialize Firebase
const app = initializeApp(firebaseConfig)
const auth = getAuth(app)
const googleProvider = new GoogleAuthProvider()
export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider)
    return result.user
  } catch (error) {
    console.error('Error signing in with Google', error)
    throw error
  }
}
export const logOut = async () => {
  try {
    await signOut(auth)
  } catch (error) {
    console.error('Error signing out', error)
    throw error
  }
}
export { auth }
